class ConfirmacaoExTipiController extends AbstractController
  @$inject = ['$injector', '$scope', 'pathService', 'confirmacaoExTipiService']

  constructor: ($injector, @scope, pathService, @confirmacaoExTipiService) ->
    super($injector)

    @loadingTracker = @promiseTracker()
    url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/pis-cofins/confirmacao-ex-tipi/"
    @modalConfirmacaoExTipi = @openPopup(url + "modal.html", 'confirmacaoExTipiModalController as ctrl', "lg", "static")

    @listOfConfirmacaoExTipi = []

    @filtro =
      descricao: ''
      pendente: true

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @loadData()


  loadData: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page

    @loadingTracker.addPromise @confirmacaoExTipiService.getList(filtro, (result) =>
      if result.success
        @listOfConfirmacaoExTipi = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar a lista de confirmações de ExTipi.', 'Erro!', false)
    )

  detalhes: (confirmacaoExTipi) ->
    @modalConfirmacaoExTipi({confirmacaoExTipi: -> confirmacaoExTipi}, (result) =>
      if result.ok
        confirmacaoExTipi.exTipi = result.data.exTipi
        confirmacaoExTipi.confirmado = result.data.confirmado
    )


class ConfirmacaoExTipiModalController extends AbstractController
  @$inject = ['$injector', 'gql', 'pathService', 'confirmacaoExTipiService', 'consultaNcmService', '$uibModalInstance', 'confirmacaoExTipi' ]

  constructor: ($injector, @gql, pathService, @confirmacaoExTipiService, @consultaNcmService, @modalInstance, confirmacaoExTipi) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @loadingTracker = @promiseTracker()
    @confirmacaoExTipi = angular.copy confirmacaoExTipi
    @exTipiConfirmada = confirmacaoExTipi.exTipi || "vazio" if confirmacaoExTipi.confirmado

    @loadingTracker.addPromise @consultaNcmService.getList({ncm: @confirmacaoExTipi.ncm, exTipi: true}, (result) =>
      if result.success
        @listOfExTipi = result.data.items.map((ncm) =>
          { exTipi: ncm.classificacaoBusca.toString().substr(-2), descricao: ncm.descricao }
        )
      else
        Alert.error('Ocorreu um erro ao consultar!', 'Erro')
    )

  confirmar: ->
    exTipi = if @exTipiConfirmada == 'vazio' then null else @exTipiConfirmada
    @submitTracker.addPromise @confirmacaoExTipiService.save({id: @confirmacaoExTipi.id, exTipi: exTipi}, (result) =>
      if result.success
        @gql.mutate(gql(["mutation ($ncm: String!, $codigoBarras: String) {
          deleteAuditoriasContinuas(ncm: $ncm, codigoBarras: $codigoBarras)
        }"]), { ncm: @confirmacaoExTipi.ncm, codigoBarras: @confirmacaoExTipi.codigoBarras })

        Alert.success("Confirmação de ExTIPI Nº <strong>#{@confirmacaoExTipi.id}</strong> confirmada com sucesso.", 'Sucesso!')

        @modalInstance.close(new Retorno(true, null, result.data)))

  delete: ->
    Confirm.warning('Atenção', 'Deseja realmente excluir está confirmação de ExTIPI e relatar o NCM desde produto como inconsistente?', {
      'Sim': =>
        @confirmacaoExTipiService.delete({id: @confirmacaoExTipi.id, status: 'ncm_inconsistente'}, (data) =>
          if data
            Alert.success("O NCM inconsistente para a confirmação de ExTIPI Nº <strong>#{@confirmacaoExTipi.id}</strong> foi cadastrado com sucesso!", 'Sucesso!')
            @modalInstance.close(new Retorno(true, null, data))
        )
      'Não': => null
    })  

angular.module('eficienciaFiscalModule').controller('confirmacaoExTipiController', ConfirmacaoExTipiController)
angular.module('eficienciaFiscalModule').controller('confirmacaoExTipiModalController', ConfirmacaoExTipiModalController) 
